import AbstractDyEventComponent from './abstract-event.component';
import { IDynamicYieldEvent } from '../interfaces/dynamic-yield.interface';
import { CODE_BACKSPACE, supportsPassiveEvents } from '@contorion/core';

export class DyKeystrokeEventComponent extends AbstractDyEventComponent {
    protected keyDownEventHandler: any;
    protected get payload(): IDynamicYieldEvent {
        return {
            name: 'keystroke',
            properties: {
                customEventValue: 'backspace',
            }
        };
    }

    constructor(protected element: HTMLElement) {
        super(element);
    }

    protected bindEvents(): void {
        this.keyDownEventHandler =  this.onKeyDown.bind(this);
        this.element.addEventListener(
            'keydown',
            this.keyDownEventHandler,
            { passive: supportsPassiveEvents }
        );
    }

    protected onKeyDown(e: KeyboardEvent): void {
        if (e.code !== CODE_BACKSPACE) {
            return;
        }
        this.element.removeEventListener(
            'keydown',
            this.keyDownEventHandler
        );

        this.emitEvent();
    }
}
